import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'mails',
    pluginName: 'ADMIN',
    entityName: 'SENT_MAIL',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch sent mails action creators
export const fetchSentMailInit = () => {
    return crudActions.fetchInit();
};
export const fetchSentMailStart = () => {
    return crudActions.fetchStart();
};
export const fetchSentMailSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchSentMailFail = () => {
    return crudActions.fetchFail();
};
export const fetchSentMailCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchSentMailStart());
        try {
            let countRes = await rest.post("/mails/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchSentMailSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchSentMailFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch sent mails."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchSentMailFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch sent mails."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchSentMail = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchSentMailStart());
        try {
            let listRes = await rest.post("/mails/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchSentMailSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchSentMailFail());
            return []

        } catch (error) {
            dispatch(fetchSentMailFail());
            return []
        }
    }
}